import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { AccordionItem } from './ui/AccordionItem';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito vivir en USA para vender en Amazon.com?',
    a: 'No. Amazon permite que vendedores de muchos países abran cuenta. En el ebook explicamos los requisitos, opciones de cobro (Payoneer, Wise) y consideraciones logísticas para vender desde LatAm o España.'
  }, {
    q: '¿Cuánto cobra Amazon realmente?',
    a: 'Depende de la categoría y el producto. En general: referral fee (8-15%), FBA fee ($3-5 por unidad típica), storage fee mensual y el plan de vendedor ($39.99/mes en Professional). El ebook incluye ejemplos detallados y cómo calcular tu P&L.'
  }, {
    q: '¿Qué modelo de Amazon me conviene?',
    a: 'Depende de tu presupuesto, tiempo disponible y tolerancia al riesgo. El ebook compara Private Label, Wholesale y Arbitraje con pros, contras y capital mínimo para que tomes una decisión informada.'
  }, {
    q: '¿Esto sirve si empiezo con poco dinero?',
    a: 'Sí. Incluimos una ruta específica para quienes tienen capital limitado, enfocada en arbitraje y wholesale ligero, con pasos para validar antes de escalar.'
  }, {
    q: '¿El ebook incluye proveedores específicos?',
    a: 'Incluye guías sobre dónde y cómo buscar proveedores (Alibaba, distribuidores, ferias), qué preguntar, cómo negociar y red flags. No es una lista de proveedores específicos, sino las herramientas para encontrarlos tú mismo.'
  }, {
    q: '¿Incluye plantillas y checklists?',
    a: 'Sí. Incluye plantillas de P&L, checklists de validación de producto, checklist de lanzamiento y un plan de acción de 30 días.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'Varía enormemente según el modelo, capital y dedicación. El ebook es transparente: no prometemos plazos. Lo que sí damos es un plan estructurado para que avances lo más eficientemente posible.'
  }, {
    q: '¿Hay política de reembolso?',
    a: 'Ofrecemos una garantía de satisfacción de 7 días. Si el contenido no cumple con lo prometido, contáctanos para un reembolso completo.'
  }];
  return <SectionWrapper data-id="element-116">
      <div className="text-center mb-12" data-id="element-117">
        <h2 className="text-3xl font-bold text-slate-900" data-id="element-118">
          Preguntas frecuentes
        </h2>
      </div>
      <div className="max-w-3xl mx-auto divide-y divide-slate-200" data-id="element-119">
        {faqs.map((faq, index) => <AccordionItem key={index} title={faq.q} data-id="element-120">
            {faq.a}
          </AccordionItem>)}
      </div>
    </SectionWrapper>;
}